import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GenericOrderDetail, ImportOrderInformation } from 'src/app/domain/models/ImportOrder';
import { Routes } from 'src/app/infrastructure/routes';
import { OrderUtils } from '../../util/order-utils';

@Component({
  selector: 'app-detail-order-card',
  templateUrl: './detail-order-card.component.html',
  styleUrls: ['./detail-order-card.component.css']
})
export class DetailOrderCardComponent implements OnInit {

  @Input()
  importOrderInformation!: ImportOrderInformation

  @Input()
  showDetails: boolean = false;

  details: GenericOrderDetail[] = []


  constructor(private _router: Router)
  {
  }
  ngOnInit(): void {
    if(this.importOrderInformation){
      this.details = this.importOrderInformation.genericDetails;
    }
  }

    goToVerifyPallets(orderDetailId: number) {
      if(this.importOrderInformation) {
        if(!this.importOrderInformation.importOrder.isFrozenFruit)
          this._router.navigate(['/' + Routes.adminVerifyPallets, orderDetailId])
        else
          this._router.navigate(['/' + Routes.adminFrozenFruitVerifyPalletsPage, orderDetailId])
      }
    }

  getOrderTitle(): string {
    return OrderUtils.getOrderTitle(this.importOrderInformation?.importOrder.sequence)
  }
}
